module.exports = __webpack_public_path__ + "static/tech-Icon-bullseye-d75df8bc06a039b348ac0d94fb1d6174.png";